import { useGoogleLogin as useGoogleLoginOriginal } from '@react-oauth/google';
import { createContext, useContext } from 'react';

export interface SocialLogin {
  useGoogleLogin: (
    ...args: Parameters<typeof useGoogleLoginOriginal>
  ) => ReturnType<typeof useGoogleLoginOriginal>;
}

export const SocialLoginContext = createContext<SocialLogin>({
  useGoogleLogin: useGoogleLoginOriginal,
});

export const useGoogleLogin = (
  ...args: Parameters<typeof useGoogleLoginOriginal>
) => useContext(SocialLoginContext).useGoogleLogin(...args);
